import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye } from "lucide-react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import StatusBadge from "@/components/StatusBadge";
import { Skeleton } from "@/components/ui/skeleton";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

export default function TrainerMembers() {
  const navigate = useNavigate();
  const [members, setMembers] = useState(null);
  useEffect(() => { api.get("/members").then((r) => setMembers(r.data)); }, []);

  return (
    <div data-testid="trainer-members-page">
      <PageHeader title="Üyelerim" subtitle={`Sana atanmış ${members?.length ?? "—"} üye`} />
      {members === null ? (
        <div className="space-y-2">{[...Array(5)].map((_, i) => <Skeleton key={i} className="h-16 rounded-xl bg-[#13131C]" />)}</div>
      ) : members.length === 0 ? (
        <div className="text-center py-20 text-[#68687B]">Henüz atanmış üyen yok.</div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-3">
          {members.map((m) => (
            <button key={m.id} onClick={() => navigate(`/trainer/members/${m.id}`)} data-testid={`trainer-member-${m.id}`}
              className="flex items-center gap-3 p-4 rounded-2xl bg-[#13131C] border border-[#222230] hover:border-[#FF5500]/40 transition-all text-left group">
              <Avatar className="w-11 h-11"><AvatarFallback className="bg-[#1B1B27] text-[#FF5500] text-sm font-bold">{m.name.split(" ").map((w) => w[0]).slice(0, 2).join("")}</AvatarFallback></Avatar>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-white">{m.name}</p>
                <p className="text-xs text-[#68687B]">{m.package_name ? `${m.remaining_lessons} ders kaldı` : m.goal || "—"}</p>
              </div>
              <StatusBadge status={m.status} />
              <Eye size={16} className="text-[#68687B] group-hover:text-white" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
